module.exports = __webpack_public_path__ + "img/svg/send.c3d3fef1cc1c4d22bd5727745c09e43b.svg";